import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { BodyText, useResponsive } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardsSubheadingTextWrapper = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  return (
    <BodyText sizeMatch={['14', '18']} style={match([undefined, styles.subheadingSM])}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  subheadingSM: {
    textAlign: 'center',
  },
});
